import defaultsDeep from 'lodash/defaultsDeep';
import commonFromUrlTransformerFactory from '@atlassian/jira-common-query-param-adapter/src/transformers/url-to-query.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
// eslint-disable-next-line jira/import-whitelist
import { initialQuery } from '@atlassian/jira-project-directories-components/src/query-param-adapter/model/constants/initial-query.tsx';
// eslint-disable-next-line jira/import-whitelist
import { queryFromUrl } from '@atlassian/jira-project-directories-components/src/query-param-adapter/transformers/query-from-url.tsx';
// eslint-disable-next-line jira/import-whitelist
import { getPrefetchedData as fetchData } from '@atlassian/jira-project-directories-components/src/state/requests/retrieve.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (
	{ match: { params }, query }: RouterDataContext,
	{ tenantContext: { baseUrl } }: ResourceStoreContext,
) => {
	const restQuery = defaultsDeep(
		commonFromUrlTransformerFactory(queryFromUrl)(query),
		initialQuery,
	);

	try {
		const data = await fetchData(baseUrl, (params && params.projectKey) || '', restQuery);
		return data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'prefetchComponents',
				packageName: 'jiraRouterResourcesProjectComponents',
			},
		});
		throw error;
	}
};
